// extracted by mini-css-extract-plugin
module.exports = {"landingSection":"landingSection_landingSection__2zr-W","isPadded":"landingSection_isPadded__3NEb1"};